import { Card } from '@/components/ui/card';

export default function LegalPage({ type = 'terms' }) {
  const titles = {
    terms: "Conditions Générales d'Utilisation",
    privacy: 'Politique de confidentialité',
    code: 'Code de conduite',
  };
  const title = titles[type] || titles.terms;
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 py-10">
      <h1 className="text-3xl font-bold mb-4">{title}</h1>
      <Card className="p-6 text-sm text-slate-700 leading-relaxed space-y-3">
        <p>Ce document décrit les règles d&apos;utilisation de la plateforme Job Kongo — Mosala na confiance.</p>
        <p>En vous inscrivant, vous acceptez notre cadre de confiance : vérification d&apos;identité, paiement exclusivement via la plateforme, interdiction formelle de paiement en dehors.</p>
        <p>La plateforme protège vos données (pièces d&apos;identité, photos, messages) et ne les utilise qu&apos;à des fins de vérification et de sécurité.</p>
        <p>En cas de litige, l&apos;équipe Job Kongo médie avec transparence et peut rembourser partiellement ou totalement via le fonds d&apos;assurance.</p>
        <p className="italic text-slate-500">Pour toute question, contactez hello@jobkongo.com.</p>
      </Card>
    </div>
  );
}
